import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-react';
import { makeStyles } from './styles';
import { getRestProps, addStyle } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    borderType = _this$get.borderType,
    position = _this$get.position,
    type = _this$get.type,
    theme = _this$get.theme,
    margin = _this$get.margin,
    style = _this$get.style;
  var k = this.config.k;
  var _style = {};
  if (typeof margin === 'number') {
    var _margin = type === 'vertical' ? "0 " + margin + "px" : margin + "px 0";
    _style.margin = _margin;
  }
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-divider"] = true, _classNameObj[k + "-" + (theme === 'dark' ? 'dark' : 'light')] = theme, _classNameObj[k + "-" + type] = type, _classNameObj[k + "-" + margin] = margin && typeof margin !== 'number', _classNameObj[k + "-with-text"] = children && type === 'horizontal', _classNameObj[k + "-" + position] = position !== 'center', _classNameObj[makeStyles(k, borderType)] = true, _classNameObj[className] = className, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'style': addStyle(style, _style)
  }), children && type === 'horizontal' ? _$ce(2, 'div', children, 0, _$cn(k + "-divider-text")) : undefined);
}
;